window.o_global = window.o_global || {};
window.o_global.pali = window.o_global.pali || {};

window.o_global.pali.plAccordion = {
  /**
   * @param {HTMLElement} target
   */
  toggleContent(target) {
    target.classList.toggle("pl_accordion__header--open");

    if (
      navigator.userAgent.indexOf("Safari") !== -1 &&
      navigator.userAgent.indexOf("Chrome") === -1
    ) {
      if (target.classList.contains("pl_accordion__header--open")) {
        target.parentElement.style.overflow = "auto";
      } else {
        target.parentElement.style.overflow = "hidden";
      }
    }
  },
  /**
   * @param {Event} event
   */
  clickHandler(event) {
    window.o_global.pali.plAccordion.toggleContent(event.target);
    window.o_global.eventQBus.emit("assets.accordion.toggled", event);
  },
};

/* eslint-disable no-param-reassign */
window.o_global.eventQBus.on("assets.accordion.init", (selector = "") => {
  const accordionHeaderElements = document.querySelectorAll(` ${selector} .pl_accordion__header`);

  [].forEach.call(
    accordionHeaderElements,
    /**
     * @param {HTMLElement} header
     */
    (header) => {
      header.addEventListener("click", window.o_global.pali.plAccordion.clickHandler);
    }
  );
});

window.o_global.eventLoader.onAllScriptsExecuted(130, () => {
  window.o_global.eventQBus.emit("assets.accordion.init", "body");
});
